// extracted by mini-css-extract-plugin
export default {"container":"PaymentResult_container__OssUQ","fadeContainer":"PaymentResult_fadeContainer__zQSrX","skeletonLoadingAnimation":"PaymentResult_skeletonLoadingAnimation__vukxI"};